var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_6179)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#paint0_linear_503_6179)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15309 18.9919H5.21066V9.66439H8.15309V18.9919ZM6.67984 8.37181C6.34607 8.36993 6.02034 8.26943 5.74375 8.08298C5.46716 7.89653 5.25212 7.6325 5.12575 7.3242C4.99939 7.0159 4.96737 6.67715 5.03373 6.3507C5.1001 6.02426 5.26187 5.72475 5.49864 5.48997C5.73541 5.2552 6.03656 5.09568 6.36409 5.03154C6.69162 4.96741 7.03085 5.00154 7.33896 5.12963C7.64707 5.25771 7.91025 5.47401 8.0953 5.75123C8.28035 6.02844 8.37896 6.35415 8.3787 6.68725C8.38185 6.91025 8.33998 7.13161 8.25558 7.33813C8.17118 7.54464 8.04598 7.73208 7.88745 7.88928C7.72891 8.04648 7.54029 8.17022 7.33282 8.25312C7.12535 8.33602 6.90327 8.37638 6.67984 8.37181ZM18.9986 19H16.0576V13.9043C16.0576 12.4015 15.4174 11.9376 14.5911 11.9376C13.7186 11.9376 12.8623 12.5941 12.8623 13.9423V19H9.91991V9.67117H12.7495V10.9638H12.7876C13.0716 10.39 14.0665 9.4094 15.5846 9.4094C17.2264 9.4094 19 10.3819 19 13.2302L18.9986 19Z",
    fill: "#121212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_503_6179",
    x1: 0.868964,
    y1: -8.89284,
    x2: 36.6979,
    y2: 5.97339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9C600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5001"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_6179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.96452c287c3c06eee3d4cb4c04db312a.svg";
export { ForwardRef as ReactComponent };